import { AuthContext, LoadingContext } from "../../context/contextProvider";
import { Col, Row } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import {
  ScheduledOrderColumnsEnum,
  SortDirections,
  StatusEnum,
  ThemeColorsEnum,
} from "../../constants/enums";

import AddButton from "../../components/buttons/AddButton";
import { AppRoutes } from "../../constants/appRoutes";
import Card from "../../components/cards/Card";
import Constants from "../../constants/constants";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EmptyDataBox from "../../components/dataTables/EmptyDataBox";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import LoadingButton from "../../components/buttons/LoadingButton";
import NSDataTable from "../../components/dataTables/NSDataTable";
import NSDataTablePagination from "../../components/dataTables/NSDataTablePagination";
import { Navigate } from "react-router-dom";
import Page from "../Page";
import { Search } from "../../models/searchFilterRequest";
import Services from "../../services/services";
import WorkOrderFilterRequest from "../../models/workOrderFilterRequest";
import useCurrentUserInfo from "../../hooks/useCurrentUserInfo";
import useSchedulesDataTable from "../../hooks/useSchedulesDataTable";

const title = "Schedules";
const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashhboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: EventRepeatIcon,
    title: title,
  },
];

const ScheduledOrdersPage = (props) => {
  // data-tables - start
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(Constants.defaults.rowsPerPage);
  const [paginationData, setPaginationData] = useState({
    from: null,
    pages: null,
    records: null,
    to: null,
  });
  const [searchValue, setSearchValue] = useState("");
  const [sortOptions, setSortOptions] = useState({
    column: ScheduledOrderColumnsEnum.name,
    direction: SortDirections.ascending,
  });
  // data-tables - end
  const [schedules, setSchedules] = useState([]);

  const { setLoading } = useContext(LoadingContext);
  const { currentClient } = useContext(AuthContext);

  const dataTableInfo = useSchedulesDataTable(handleDeleted);
  const userInfo = useCurrentUserInfo();

  useEffect(() => {
    getSchedulesAsync((currentPage - 1) * pageSize, pageSize, searchValue);
    return () => {};
  }, [currentClient, currentPage, pageSize, searchValue, sortOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const getSchedulesAsync = async (
    start = 0,
    take = Constants.defaults.rowsPerPage,
    searchText = null
  ) => {
    // filter
    const filter = new WorkOrderFilterRequest();
    filter.search = new Search(searchText);
    filter.start = start;
    filter.length = take;
    filter.status = StatusEnum.active;
    filter.isDirectDrop = false;
    filter.isSchedule = true;
    filter.order[0].column = sortOptions.column; // workOrdersDataTables.defaultSortColumn;
    filter.order[0].dir = sortOptions.direction; // workOrdersDataTables.defaultSortOrder;

    setLoading(true);
    const response = await Services.api.workOrders.getWorkOrders(
      JSON.stringify(filter)
    );
    setLoading(false);

    if (!response.ok)
      return Services.utility.toast(
        "Could not fetch the schedules",
        ThemeColorsEnum.error
      );

    setSchedules(response.data?.data);
    setPaginationData({
      from: (currentPage - 1) * pageSize + 1,
      pages: response.data?.pagesTotal,
      records: response.data?.recordsTotal,
      to:
        currentPage * pageSize > response.data?.recordsTotal
          ? response.data?.recordsTotal
          : currentPage * pageSize,
    });
  };

  function handleDeleted(schedule) {
    setSchedules(schedules.filter((x) => x.id !== schedule.id));
  }

  const handlePageChange = async (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newPerPage, currentPage) => {
    setCurrentPage(1);
    setPageSize(newPerPage);
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  const handleSort = (column, direction) => {
    setCurrentPage(1);
    setSortOptions({ column: column, direction: direction });
  };

  // if (!currentClient.hasSchedules)
  //   return (
  //     <Navigate
  //       to={{
  //         pathname: AppRoutes.deliveryOrders,
  //       }}
  //     />
  //   );

  const DataTableButtons = (
    <>
      <AddButton
        to={AppRoutes.scheduledOrders_create}
        visible={userInfo.canCreateDeliveryOrders}
      />
      {/* <LoadingButton
          color={ThemeColorsEnum.quaternary}
          loading={loading}
          onClick={handleRefresh}>
          Refresh
        </LoadingButton> */}
    </>
  );

  return (
    <Page breadcrumbs={breadcrumbs} title={title}>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                {/* **** BOOTSTRAP PAGINATION **** */}
                <NSDataTablePagination
                  from={paginationData?.from}
                  lastPage={paginationData?.pages}
                  page={currentPage}
                  pageSize={pageSize}
                  total={paginationData?.records}
                  to={paginationData?.to}
                  onPageChange={handlePageChange}
                  onPageSizeChange={(newPerPage) =>
                    handleRowsPerPageChange(newPerPage, currentPage)
                  }
                />
                {/* **** DATA TABLE **** */}
                <NSDataTable
                  buttons={DataTableButtons}
                  className="dataTable table-no-more"
                  // dense
                  columns={dataTableInfo.columns}
                  //   conditionalRowStyles={conditionalRowStyles}
                  data={schedules}
                  emptyDataComponent={<EmptyDataBox />}
                  onSearch={handleSearch}
                  onSort={handleSort}
                  paginate
                  search
                  sortBy={sortOptions.column}
                  sortDirection={sortOptions.direction}
                />
                {/* **** BOOTSTRAP PAGINATION **** */}
                <NSDataTablePagination
                  from={paginationData?.from}
                  lastPage={paginationData?.pages}
                  page={currentPage}
                  pageSize={pageSize}
                  showRecordsInfo
                  total={paginationData?.records}
                  to={paginationData?.to}
                  onPageChange={handlePageChange}
                  onPageSizeChange={(newPerPage) =>
                    handleRowsPerPageChange(newPerPage, currentPage)
                  }
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Page>
  );
};

export default ScheduledOrdersPage;
